import { Link } from "@inertiajs/react"
import { ChevronRight, Home } from "lucide-react"

export function Breadcrumbs({ items }) {
  return (
    <nav className="flex items-center gap-2 text-sm text-zinc-500 min-w-0">
      <Link
        href="/"
        className="flex items-center gap-1 shrink-0 hover:text-kf-red transition-colors"
      >
        <Home className="w-4 h-4" />
        <span className="sr-only">Home</span>
      </Link>

      {items.map((item, index) => (
        <span key={index} className={`flex items-center gap-2 ${item.href ? "shrink-0" : "min-w-0"}`}>
          <ChevronRight className="w-4 h-4 shrink-0 text-zinc-300" />
          {item.href ? (
            <Link
              href={item.href}
              className="hover:text-kf-red transition-colors"
            >
              {item.label}
            </Link>
          ) : (
            <span className="text-zinc-900 font-medium truncate">
              {item.label}
            </span>
          )}
        </span>
      ))}
    </nav>
  )
}
